/*
 * @Author: Nie Wie
 * @Date: 2020-01-06 15:18:36
 * @LastEditors  : Liu Dan
 * @LastEditTime : 2023-01-03 11:19:26
 * @Description: 常量
 */

_.take = require('lodash/take')

// 登陆成功后到跳转登录页的等待时间
export const LOGIN_SUCCESS_WAIT = 300

// 登陆失败后,显示失败文字的时间
export const LOGIN_UNSUCCESS_TEXT_TIME = 1000

export const LOGIN_PROCESS_STATES = {
  SUCCESS: 'SUCCESS',
  UNSUCCESS: 'UNSUCCESS',
  DEFAULT: 'DEFAULT',
}

// 默认的时间轴显示时间跨度(1000 * 60 * 60 *3) 3个小时
export const CHART_X_LENTH = 10800000

export const MAP_CENTER = [ 104.29482679000004, 33.008197853850035 ]

export const MAP_ZOOM = 4

const base = [ 8182109.711296054, 705353.3433710118, 15037984.30997489, 7087430.940508386 ]

export const MAP_DEFAULT_EXTENT = base

export const COVERAGE_TIMELINE_DATA2022 = [
  {
    quarter: 1,
    title: 'Q1',
    value: '202201',
    type: 2,
    typeName: '一季度',
  },
  {
    quarter: 2,
    title: 'Q2',
    value: '202202',
    type: 2,
    typeName: '二季度',
  },
  {
    title: 'H1',
    value: '202201',
    type: 10,
    typeName: '上半年',

  },
  {
    quarter: 3,
    title: 'Q3',
    value: '202203',
    type: 2,
    typeName: '三季度',
  },
  {
    quarter: 4,
    title: 'Q4',
    value: '202204',
    type: 2,
    typeName: '四季度',

  },
  {
    title: 'H2',
    value: '202202',
    type: 10,
    typeName: '下半年',
  },
  {
    title: 'YEAR',
    typeName: '全年',
    value: '2022',
    type: 1,
  },
]

export const COVERAGE_TIMELINE_DATA2023 = [
  {
    quarter: 1,
    title: 'Q1',
    value: '202301',
    type: 2,
    typeName: '一季度',
  },
  {
    quarter: 2,
    title: 'Q2',
    value: '202302',
    type: 2,
    typeName: '二季度',
  },
  {
    title: 'H1',
    value: '202301',
    type: 10,
    typeName: '上半年',

  },
  {
    quarter: 3,
    title: 'Q3',
    value: '202303',
    type: 2,
    typeName: '三季度',
  },
  {
    quarter: 4,
    title: 'Q4',
    value: '202304',
    type: 2,
    typeName: '四季度',

  },
  {
    title: 'H2',
    value: '202302',
    type: 10,
    typeName: '下半年',
  },
  {
    title: 'YEAR',
    typeName: '全年',
    value: '2023',
    type: 1,
  },
]

export const COVERAGE_TIMELINE_DATA2024 = [
  {
    quarter: 1,
    title: 'Q1',
    value: '202401',
    type: 2,
    typeName: '一季度',
  },
  {
    quarter: 2,
    title: 'Q2',
    value: '202402',
    type: 2,
    typeName: '二季度',
  },
  {
    title: 'H1',
    value: '202401',
    type: 10,
    typeName: '上半年',

  },
  {
    quarter: 3,
    title: 'Q3',
    value: '202403',
    type: 2,
    typeName: '三季度',
  },
  {
    quarter: 4,
    title: 'Q4',
    value: '202404',
    type: 2,
    typeName: '四季度',

  },
  {
    title: 'H2',
    value: '202402',
    type: 10,
    typeName: '下半年',
  },
  {
    title: 'YEAR',
    typeName: '全年',
    value: '2024',
    type: 1,
  },
]

export const COVERAGE_TIMELINE_DATA2025 = [
  {
    quarter: 1,
    title: 'Q1',
    value: '202501',
    type: 2,
    typeName: '一季度',
  },
  {
    quarter: 2,
    title: 'Q2',
    value: '202502',
    type: 2,
    typeName: '二季度',
  },
  {
    title: 'H1',
    value: '202501',
    type: 10,
    typeName: '上半年',

  },
  {
    quarter: 3,
    title: 'Q3',
    value: '202503',
    type: 2,
    typeName: '三季度',
  },
  {
    quarter: 4,
    title: 'Q4',
    value: '202504',
    type: 2,
    typeName: '四季度',

  },
  {
    title: 'H2',
    value: '202502',
    type: 10,
    typeName: '下半年',
  },
  {
    title: 'YEAR',
    typeName: '全年',
    value: '2025',
    type: 1,
  },
]

export const COVERAGE_TIMELINE_DATA = [
  {
    quarter: 1,
    title: 'Q1',
    value: '202601',
    type: 2,
    typeName: '一季度',
  },
  {
    quarter: 2,
    title: 'Q2',
    value: '202602',
    type: 2,
    typeName: '二季度',
  },
  {
    title: 'H1',
    value: '202601',
    type: 10,
    typeName: '上半年',

  },
  {
    quarter: 3,
    title: 'Q3',
    value: '202603',
    type: 2,
    typeName: '三季度',
  },
  {
    quarter: 4,
    title: 'Q4',
    value: '202604',
    type: 2,
    typeName: '四季度',

  },
  {
    title: 'H2',
    value: '202602',
    type: 10,
    typeName: '下半年',
  },
  {
    title: 'YEAR',
    typeName: '全年',
    value: '2026',
    type: 1,
  },
]
